// The code in this file will load on every page of your site
import wixWindow from 'wix-window';
import { memory } from 'wix-storage';
import { toggleMenu } from 'public/helpers.js';
import { getUserDetails } from 'public/wixUsers';
import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/BIEventsFunctions';

let formFactor = wixWindow.formFactor;
let savedUserEmail

$w.onReady(function () {
    if (wixWindow.rendering.env === "browser") {
        // Write your code here
        // if (formFactor !== "Mobile") {
        //     toggleMenu($w('#horizontalMenuSmall'), $w('#horizontalMenuBig'));
        //     // showSearcchType()
        // }
        $w('#getSubscribers1').onWixFormSubmit(() => {
            $w("#columnStripSubscribe").scrollTo();
        })
        $w("#getSubscribers1").onWixFormSubmitted((formDetails) => {
            $w("#columnStripSubscribe").scrollTo();
            const button_name = $w('#buttonJoinNewsletter').label || '';
            const biEventFields = {
                button_name,
                topic: 'Wix Blog',
                url: wixLocation.url
            }
            fireBIEvent(19, 402, biEventFields);
        });

        showBanner();
    }
});

function showBanner() {
    // CHECK IF IT'S A USER
    getUserDetails().then(user => {
            savedUserEmail = user.email
            // if (user.email) {

            // }

        })
        .catch((err) => {
            console.log("showBannerERR")

            let boolUserSawBannner = memory.getItem("userSawBanner"); // "value"
            setTimeout(function () {
                if (boolUserSawBannner === null) {
                    memory.setItem("userSawBanner", "true");
                    if (formFactor !== "Mobile") {
                        wixWindow.openLightbox("Banner");
                    }
                }
            }, 3000);
            let errMsg = err.message;
            let errCode = err.code;
        });

}